import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledItemContent,
  StyledItemDate,
  StyledItemImage,
  StyledList
} from './OutOfOfficeArchive.styled';

const OutOfOfficeArchive: React.FC = () => {
  const { t } = useI18n('out-of-office');

  const archiveItems = [
    {
      title: t('out-of-office.archive.issue1.title'),
      date: t('out-of-office.archive.issue1.date'),
      url: 'https://none.clickacm.com/show/qgJ2lZXPBBizIfJi3pmS/',
      image: getPublicPath('/images/outOfOffice/issue1.jpg')
    },
    {
      title: t('out-of-office.archive.issue2.title'),
      date: t('out-of-office.archive.issue2.date'),
      url: 'https://none.clickacm.com/show/b1615334-31d5-11ee-8de4-005056bd5094/',
      image: getPublicPath('/images/outOfOffice/issue2.jpg')
    },
    {
      title: t('out-of-office.archive.issue3.title'),
      date: t('out-of-office.archive.issue3.date'),
      url: 'https://none.clickacm.com/show/wu6deAtfPCX9motAD1CNjCqWmkkfoGdPylR2qmODcVrN426OfAqJlcaDTAw/',
      image: getPublicPath('/images/outOfOffice/issue3.jpg')
    }
  ];

  return (
    <StyledContainer>
      <Heading2>{t('out-of-office.archive.title')}</Heading2>
      <HtmlTrans
        ns={'out-of-office'}
        i18nKey={'out-of-office.archive.desc'}
      ></HtmlTrans>
      <StyledList>
        {archiveItems.map((item, index) => (
          <div key={index}>
            <StyledItemImage>
              <img src={item.image} alt="" />
            </StyledItemImage>
            <StyledItemContent>
              <a href={item.url} target="_blank">
                {item.title}
              </a>
              <StyledItemDate>{item.date}</StyledItemDate>
            </StyledItemContent>
          </div>
        ))}
      </StyledList>
    </StyledContainer>
  );
};

export default OutOfOfficeArchive;
